import { Product } from "../../types/types";

export const getProductKey = (product: Product): string => {
  return `${product.aliases.pimProductId}-${product.advertising ? "sponsored" : "standard"}`;
};
